import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/automation-schedule')({
    component: AutomationSchedulePage,
});

function AutomationSchedulePage() {
    return <Navigate to="/settings/shift-confirmations" replace={true} />;
}
